import React from 'react'

type SelectedWorkUnitAndBusinessUnit = {
  parent_id?: number | null
  phone?: string | null
  config?: any
  client_id: number
  email?: string
  logo?: string | null
  id: number
  user_id?: number
  contact?: string
  hash_business_unit: string
  fiscal_data_id?: number
  state?: string
  short_name: string
  token: string
  country_id?: number
  long_name: string
  is_agency?: boolean
  business_type_id?: number
  description?: string
  agency_id?: number | null
  work_unit_id?: number
  fantasy_name?: string
  is_active: boolean
  salesperson_user_id?: number
  address?: string
  salesperson_user_id_relation?: any
  client_relation?: any
  children?: any[]
  currency_relation?: any[]
  user_relation?: any[]
  business_type?: any
  work_unit?: any
}

export type Reservation = {
  number: string | null
  status: string | null
  hash_reservation: string | null
  payment_amount : number | null
  status_payment: string | null
}

export type FormData = {
  payment_type: string | null,
  payment_method_id: number | null, 
  bank_info:  object | null,
  card_info: object | null,
  payment_date: Date  | null,
  amount: number | null, 
  currency_info: object | null,
  cash_info: object | null,
  check_type: string | null,
  retentions: Retenciones[] | null,
  wallet_info: object | null,
}

export type Retenciones = {
  has_retention: string | null,
  retention_type: string | null,
  retention_amount: string | null,
  retention_certificate: string | null,
  retention_files: number[] | null,
}

export type PaymentData = {
  business_unit_info: object | null,
  work_unit_info: object | null,
  payments: FormData[] | null,
  reservations_info: Reservation[] | null,
  selectedBusinessUnit: SelectedWorkUnitAndBusinessUnit | null
  user_info: object | null,
  observation_internal: string | null,
}

// Tipo para PaymentCurrencies
type CurrencyRelation = {
  hash_currency: string
  long_name: string
  id: number
  symbol: string
  short_name: string
}

export type PaymentCurrency = {
  id: number
  long_name: string
  short_name: string
  symbol: string
  hash_currency: string
}

export type PaymentExchange = {
  is_reverse: boolean
  value: number
  currency_id: number
  currency_to_id: number
  work_unit_id: number
  currency_relation: CurrencyRelation
  currency_to_relation: CurrencyRelation
}

// Context Type
type BillingContextType = {
  reservationIds: number[]
  setReservationIds: (reservationIds: number[]) => void
  paymentData: PaymentData
  setPaymentData: (paymentDate: PaymentData) => void
  paymentCurrecies: PaymentCurrency[]
  setPaymentCurrecies: (currency: PaymentCurrency[]) => void
  paymentExchanges: PaymentExchange[]
  setPaymentExchanges: (exchange: PaymentExchange[]) => void
  itemsSelected: any[]
  setItemsSelected: (itemSelected: any[]) => void
  paymentCredit: any[]
  setPaymentCredit: (paymentCredit: any[]) => void
  currency: any
  setCurrency: (paymentCredit: any) => void
  isReservationOption: boolean
  setIsReservationOption: (isReservationOption: boolean) => void
}


export const BillingContext = React.createContext<BillingContextType>({
  reservationIds: [],
  setReservationIds: () => {},
  paymentData: {
    business_unit_info: null,
    work_unit_info: null,
    selectedBusinessUnit: null,
    payments: [], // Cambia esto de `null` a `[]` (array vacío)
    reservations_info: [],
    user_info: null,
    observation_internal: null
  },
  setPaymentData: () => {},
  paymentCurrecies: [],
  setPaymentCurrecies: () => {},
  paymentExchanges: [],
  setPaymentExchanges: () => {},
  itemsSelected: [],
  setItemsSelected: () => {},
  paymentCredit: [],
  setPaymentCredit: () => {},
  currency: {},
  setCurrency: () => {},
  isReservationOption: false,
  setIsReservationOption: () => {},
})

export const useBillingContext = () => React.useContext(BillingContext)
